import React, { Component } from "react";
import styled from "styled-components";
import Select from "../../common/components/form/Select";
import { Localize } from "../../../locale/localization";
import Icon from "../../../icons/Icon";
import { ICONS } from "../../../icons/Icons";
import colors from "../../../utils/colors";
import { rem } from "polished";
import find from "lodash/find";
import { StyledError, StyledInputWrapper } from "../../common/components/form/ui/index";

const Container = styled.div`
  width: 100%;

  .error {
    background: ${colors.BRAND_RED_LIGHTEST};
    width: auto;
    margin-top: -1rem;
    margin-right: 2.75rem;
  }

  p {
    color: ${colors.GRAY};
    margin-bottom: 0.5rem;
  }
`;

const Head = styled.div`
  width: 100%;
  position: relative;
  text-align: right;

  span {
    color: ${colors.GRAY};
    display: block;
    margin-right: 2.5rem;
  }

  .add {
    cursor: pointer;
    position: absolute;
    right: 0;
    top: -0.25rem;
  }
`;

const Row = styled.div`
  position: relative;
  display: flex;
  margin-bottom: 1rem;

  .channel {
    margin-right: 1.25rem;
  }
  .role {
    margin-right: 2.75rem;
  }

  .delete {
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0.75rem;
  }
`;

const operatorHead = Localize("targeting.channel");
const roleHead = Localize("targeting.role");

class ContentTargetings extends Component {
  constructor(props) {
    super(props);

    // console.log("ContentTargetings, constructor", props);
    //NOTE: selection should always have 1 empty object for the initial selection
    this.state = {
      selection: props.targetings.selection
    };
  }

  componentWillMount() {
    // console.log("ContentTargetings, componentWillMount", this.props);
    this.setState({ selection: this.props.targetings.selection });
  }

  componentWillReceiveProps(nextProps) {
    // console.log("ContentTargetings, willReceiveProps", nextProps);
    // data into component > change with inner set state > callback > receiveprops > set state
    this.setState({ selection: nextProps.targetings.selection });
  }

  onChannelChange = (event, index) => {
    const name = event.target.value;
    let selection = this.state.selection.slice();
    selection[index].channel.name = name;

    //NOTE: targetings flat, selections wrapped to channel:{}
    const item = find(this.props.targetings.targetings, function(item) {
      return item.name === name;
    });
    if (item) {
      selection[index].channel._id = item._id;
    }

    this.setState({ selection: selection }, this.onStateChanged);
  };

  onRoleChange = (event, index) => {
    const role = event.target.value;
    let selection = this.state.selection.slice();
    selection[index].role = role;

    this.setState({ selection: selection }, this.onStateChanged);
  };

  onAdd = event => {
    let selection = this.state.selection.slice();
    selection.push({
      channel: { name: "", _id: "" },
      role: "",
      _id: ""
    });
    this.setState({ selection: selection }, this.onStateChanged);
  };

  onStateChanged = () => {
    // console.log("ContentTargetings, onStateChanged state", this.state.selection);
    this.props.onChange({
      roles: this.props.targetings.roles,
      targetings: this.props.targetings.targetings,
      selection: this.state.selection
    });
  };

  onDelete = (event, index) => {
    let selection = this.state.selection.slice();
    selection.splice(index, 1);
    // console.log("ContentTargetings, onDelete index", index);
    // console.log("ContentTargetings, onDelete selection", selection);

    this.setState({ selection: selection }, this.onStateChanged);
  };

  getSelectedChannel = index => {
    const { selection } = this.state;
    if (selection[index].channel.name !== "") {
      return selection[index].channel.name;
    }

    return operatorHead;
  };

  getSelectedRole = index => {
    const { selection } = this.state;
    if (selection[index].role !== "") {
      return selection[index].role;
    }
    return roleHead;
  };

  renderRow = index => {
    return (
      <Row key={"row" + index}>
        <Select
          half
          className="channel"
          name={this.props.name}
          value={this.getSelectedChannel(index)}
          key={"channelSelect" + index}
          onChange={event => this.onChannelChange(event, index)}
        >
          <option disabled>{operatorHead}</option>
          {this.props.targetings.targetings.map((target, index) => (
            <option value={target.name} key={"channel" + index}>
              {target.name}
            </option>
          ))}
        </Select>

        <Select
          half
          className="role"
          name={this.props.name}
          value={this.getSelectedRole(index)}
          key={"roleSelect" + index}
          onChange={event => this.onRoleChange(event, index)}
        >
          <option disabled>{roleHead}</option>
          {this.props.targetings.roles.map((role, index) => (
            <option value={role.value} key={"role" + index}>
              {role.label}
            </option>
          ))}
        </Select>

        <div
          onClick={event => this.onDelete(event, index)}
          className={this.state.selection.length <= 1 ? "delete disabled" : "delete"}
        >
          <Icon
            icon={ICONS.FILTER_DEL}
            width={rem("28px")}
            height={rem("28px")}
            stroke={colors.GRAY}
          />
        </div>
      </Row>
    );
  };

  hasError = () => {
    return this.props.error && !!this.props.errorMessage;
  };

  render() {
    return (
      <Container>
        <Head>
          <span>{Localize("filters.add")}</span>
          <div onClick={this.onAdd} className="add">
            <Icon
              icon={ICONS.FILTER_ADD}
              width={rem("28px")}
              height={rem("28px")}
              stroke={colors.GRAY}
            />
          </div>
        </Head>

        <p>{Localize("filters.target")}</p>

        {this.state.selection.map((item, index) => this.renderRow(index))}

        {this.hasError() && (
          <StyledInputWrapper className={this.hasError() && "error"}>
            <StyledError dangerouslySetInnerHTML={{ __html: this.props.errorMessage }} />
          </StyledInputWrapper>
        )}
      </Container>
    );
  }
}

export default ContentTargetings;



// WEBPACK FOOTER //
// ./src/modules/content/components/ContentTargetings.js